import { Serializable } from '@admin/core/models/serializable';
import { MessageType } from './message-type.enum';
import { MessageInnerType } from './message-inner-type.enum';

export class EmailSmsTemplateModel
  implements Serializable<EmailSmsTemplateModel>
{
  fromObject(object: any): EmailSmsTemplateModel {
    Object.assign(this, object);

    return this;
  }

  toObject() {
    return {
      MessageType: this.messageType,
      MessageInnerType: this.messageInnerType,
      MessageId: this.messageId,
      MessageKeyName: this.messageKeyName,
      MessageName: this.messageName,
      messageContent: this.messageContent,
    };
  }

  public messageType: MessageType;
  public messageInnerType: MessageInnerType;
  public messageId: number;
  public messageKeyName: string;
  public messageName: string;
  public messageContent: string;

  constructor() {}
}
